// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1qhV0","title":"ClientReferral_title__27Njj","itemText":"ClientReferral_itemText__2VpEW"};